





























import Vue from 'vue'
import { BadgeLabelElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BadgeLabel',
  props: {
    templateItemData: {
      type: Object as () => BadgeLabelElInterface,
      required: true
    }
  },
  computed: {
    badgeStyle (): Record<string, string> {
      return {
        fontSize: '0.85rem',
        display: 'inline-block',
        background: this.templateItemData.badge.badgeColor ? this.templateItemData.badge.badgeColor : 'transparent',
        color: this.templateItemData.badge.badgeTextColor ? this.templateItemData.badge.badgeTextColor : 'inherit'
      }
    }
  }
})
